import { faSignOutAlt, faLock, faGear, faUser } from "@fortawesome/free-solid-svg-icons";
import { faBell } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import storageService from "../services/storage.service";
import { useHistory, useLocation } from "react-router-dom";
import { TranslationsOptions } from "../translations";
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import { setDefaultLocale } from "react-datepicker";
import { ModalAlert } from "../components/ModalAlert";
import { UserService } from "../services/user.service";
import { ModalChangePassword } from "../components/ModalChangePassword";
import { ModalEquipmentOverLimit } from "../components/ModalEquipmentOverLimit";
import { EquipmentAcknowledgeService } from "../services/equipmentacknowledge.service";

import { DatasetDefault, DatasetModel } from "../models/dataset.model";
import { FileExportService } from "../services/fileExport.service";
import { RequestInputOutputParamsModel, RequestInputOutputParamsModelDefault } from "../models/requestInputOutputParams.model";
import EventExportService from "../services/eventExport.service";
import { ModalChangePreferences } from "./ModalPreferences";
import AuthService from "../services/auth.service";

export const TopBar = () => {
  let history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();

  const [userLetters, setUserLetters] = useState('');
  const [idiomDefault, setIdiomDefault] = useState(storageService.getIdiom());
  
  const user = storageService.getUser();
  const defaultLocaleCode =
  user?.locales?.find(l => l.id === user.localeId)?.code || '';
  const [localeDefault, setLocaleDefault] = useState(defaultLocaleCode);

  const [userLocales, setUserLocales] = useState<any[]>([]);
  const [showModalChangePassword, setShowModalChangePassword] = useState(false);
  const [showModalChangePreferences, setShowModalChangePreferences] = useState(false);
  const [modalEquipmentOverLimitShow, setModalEquipmentOverLimitShow] = useState(false);
  const [equipmentOverLimitList, setEquipmentOverLimitList] = useState([]);

  const [sentAcknowledge, setSentAcknowledge] = useState(false);
  const [modalAlertActivityShow, setModalAlertActivityShow] = useState(false);
  const [modalAlertActivityHour, setModalAlertActivityHour] = useState('');

  //Sprint - 29 - Permitir exportar Equipamentos 
  const [datasetDashboardAnalytical, setDatasetDashboardAnalytical] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)),
    dataset: 'equipment',
    filters: {
      branch_id: [],
      group_id: [],
      exceeded_balance_deadline: [true],
      validade_config_feature: [],
      date_begin_end: [],
    },
    pagination: {
      page_number: 1,
      total_pages: 0,
      records_pages: 21,
      total_records: 0
    },
  });
  //Sprint - 29 - Permitir exportar Equipamentos 

  const loadUserLocales = async () => {
    const userLogged = storageService.getUser();

    try {
      const response: any = await UserService.getLocalesLogin();

      if (response?.success && response?.result) {

        const localesFromDb = response.result || [];

        setUserLocales(localesFromDb);
        const selected = localesFromDb.find(l => l.id === userLogged.localeId);
        setLocaleDefault(selected?.code || '');

        storageService.updateUser({
          ...userLogged,
          locales: localesFromDb
        });
      } else {
        setUserLocales(userLogged?.locales || []);
      }
    } catch (error) {
      console.error("Erro ao carregar locales do usuário:", error);
      setUserLocales(userLogged?.locales || []);
    }
  };

  useEffect(() => {
    const getLettersName = (name: string) => {
      let letters = '';
      let firstLetters = name?.match(/\b(\w)/g);
      if (firstLetters) {
        letters = firstLetters[0] + (firstLetters.length > 1 ? firstLetters[firstLetters.length - 1] : '');
      }
      return letters;
    };

    setUserLetters(getLettersName(storageService.getUserName()));
  }, []);

  useEffect(() => {
    loadUserLocales();
  }, []);

  useEffect(() => {
    loadUserLocales();
  }, [location.pathname]);

  useEffect(() => {
    const handleReloadLocales = () => {
      loadUserLocales();
    };

    window.addEventListener("reload-topbar-locales", handleReloadLocales);

    return () => {
      window.removeEventListener("reload-topbar-locales", handleReloadLocales);
    };
  }, []);

  const Logout = async () => {
    // Pegue o valor atual de 'idiom' do localStorage
    const idiom = localStorage.getItem('Idiom');

    // Armazene uma mensagem de logout no localStorage
    if (idiom) {
      localStorage.setItem('logout', `User logged out with idiom: ${idiom}`);
    } else {
      localStorage.setItem('logout', 'User logged out without idiom');
    }
    
    // Limpe os dados do usuário, mas preserve o idiom
    storageService.clearUserLoggedIn();
    
    // Após limpar os dados do usuário, reponha o valor do idiom
    if (idiom) {
      localStorage.setItem('idiom', idiom);
    }
    
    // Redirecione para a página de login
    history.push('/Login');
  };

  const handleClosePasswordChanging = () => {
    setShowModalChangePassword(false);
  };

  const ChangePassword = async () => {
    setShowModalChangePassword(true);
  };
  /*
  sprint3100
  Esta função é responsável por fechar o modal de mudança de preferências, 
  atualizando o estado setShowModalChangePreferences para false.
  */
  const handleClosePreferenceChanging = () => {
    setShowModalChangePreferences(false);
  };

  /*
  sprint3100
  Esta função é assíncrona e é responsável por abrir o modal de mudança de 
  preferências, atualizando o estado setShowModalChangePreferences para true.
  */
  const ChangePreferences = async () => {
    setShowModalChangePreferences(true);
  };


  const handleCloseModalEquipmentOverLimit = () => {
    console.log("Sent", sentAcknowledge)
    if (!sentAcknowledge) {
      let list = equipmentOverLimitList?.map(item => ({
        "equipmentAcknowledgeTypeId": 2,
        "equipmentId": item.id_equipment,
        "branch": item.nickname,
        "equipmentCode": item.code_equipment,
        "firstImpositionDate": item.first_over_limit_date,
        "daysWithoutCollection": !item.days_since_first_over_limit ? '0' : item.days_since_first_over_limit,
        "processed": item.acknowledge_date != null
      }));
      console.log("list", list);
      if (list && list.length > 0) {
        EquipmentAcknowledgeService.sendAcknowledge(list.filter(x => !x.processed));
      }
      setSentAcknowledge(true);
    }
    setModalEquipmentOverLimitShow(false);
  };

  /*
  Sprint 29
  Função responsável para poder criar os dados
  fazer a procedure para ter os dados de exportação
  handle referente ao Saldo Online Acima do Limite 
*/
    const handleExportButtonClick = (Type: string) => {


    let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [datasetDashboardAnalytical] };

    requestParams.parameters = {
      ...requestParams.parameters,
        Type
    }


        EventExportService.ExportEquipmentBalanceLimitExceeded(requestParams, Type).finally(() =>
        Type
    );

  };

  /*
    Esta função é responsável por abrir um modal mostrando uma lista de 
    equipamentos que excederam o limite de saldo. Ela realiza uma chamada para o 
    serviço EquipmentAcknowledgeService.getEquipmentBalanceLimitExceeded(null) 
    para obter os dados sobre os equipamentos com saldo acima do limite.
  */
  const handleOpenModalEquipmentOverLimit = () => {
    //console.log("Open Modal Equipment Limit")
    EquipmentAcknowledgeService.getEquipmentBalanceLimitExceeded(null)
      .then((response: any) => {
        //console.log("Equipment Balance Limit", response.result.datasets[0]);
        if (response.success) {
          setEquipmentOverLimitList(response.result.datasets[0].data);
        }
        setModalEquipmentOverLimitShow(true);
      })
      .catch((error) => {
        console.error('Error fetching equipment balance limit exceeded:', error);
        setModalEquipmentOverLimitShow(true); // Assuming you still want to show the modal even if there's an error
      });
  };


  useEffect(() => {
    const getLettersName = (name: string) => {
      let letters = '';
      let firstLetters = name?.match(/\b(\w)/g);
      if (firstLetters) {
        letters = firstLetters[0] + (firstLetters.length > 1 ? firstLetters[firstLetters.length - 1] : '');
      }
      return letters;
    }

    setUserLetters(getLettersName(storageService.getUserName()));

  }, [])

  const onChangeLanguage = (e) => {
    setIdiomDefault(e.target.value);
    setDefaultLocale(e.target.value.replaceAll('-', ''));
    i18n.changeLanguage(e.target.value, (err, t) => {
      if (err) return console.log('something went wrong loading', err);
      else {
        storageService.setIdiom(e.target.value);
        window.location.reload();
      }
    });
  }

  const onChangeLocale = async (event) => {
    const selectedCode = event.target.value;
    setLocaleDefault(selectedCode);

    const user = storageService.getUser();
    const selectedLocale = (userLocales || user?.locales || []).find(l => l.code === selectedCode);

    if (!selectedLocale) return;

    try {
      const response = await AuthService.changeLocale(Number(selectedLocale.id));

      if (response.success) {
        storageService.setUserLoggedIn(response.result);
        storageService.setLocale(selectedCode);
        window.location.reload();
      } else {
        console.error('Erro ao trocar locale:', response.messages);
      }
    } catch (error) {
      console.error('Erro na chamada ChangeLocale:', error);
    }
  };

  return (
    <>
      <ModalChangePassword
        Title={t("BUTTON_CHANGE_PASSWORD")}
        Message="WIP"
        cancel={t('CANCEL')}
        close={handleClosePasswordChanging}
        show={showModalChangePassword}
      />
      {/* Sprint3100 - Modal referente para selecionar a preferencia do usuario */}
      <ModalChangePreferences
        Title={t("BUTTON_PREFERENCES")}
        Message="WIP"
        cancel={t('CANCEL')}
        close={handleClosePreferenceChanging}
        show={showModalChangePreferences}
      />
      {/* Sprint3100 - Modal referente para selecionar a preferencia do usuario */}
      {/* Modal referente ao Saldo Online Acima do Limite  */}
      <ModalEquipmentOverLimit
        Title={t('MODULE_ALERT.ALERTS_BALANCE_OVER_CONTRACT_LIMIT')}
        ListAlert={equipmentOverLimitList}
        ButtonCloseLabel={`${t('MODULE_ALERT.AWARE')}`}
        /* 
          Sprint 29
          chamando o exportar do componente ModalEquipmentOverLimit 
        */
        onExportClick={handleExportButtonClick}
        HandleClose={handleCloseModalEquipmentOverLimit}
        Show={modalEquipmentOverLimitShow}>
      </ModalEquipmentOverLimit>

      {/*Sprint 31 - Ajuste do topbar */}
      <nav className='navbar navbar-expand-lg navbar-light bg-light border-bottom'>
        <div className='container-fluid'>
          <div className='collapse navbar-collapse justify-content-between' id='navbarSupportedContent'>

            {/* Canto Esquerdo - Bola Circular e Nome do Usuário */}
            <div className='d-flex'>
              <ul className='navbar-nav mt-2 mt-lg-0'>
                <li className='nav-item active d-flex align-items-center'>
                  <div
                    className='bg-primary'
                    style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#fff',
                      fontSize: '20px',
                      marginRight: '10px'
                    }}>
                    {userLetters}
                  </div>
                  <h4 className='mb-0'>{storageService.getUserName()}</h4>
                </li>
              </ul>
            </div>

            {/* Canto Direito - Seletor de Idioma e Ícone de Sino */}
            <div className='d-flex'>
              {userLocales?.length > 1 ? (
                <ul className='navbar-nav mt-2 mt-lg-0'>
                  <li className='nav-item active'>
                    <Form.Select onChange={onChangeLocale} value={localeDefault}>
                      {userLocales.map((t, index) => (
                        <option key={index} value={t.code}>
                          {t.name}
                        </option>
                      ))}
                    </Form.Select>
                  </li>
                </ul>
              ) : null}
              <ul className='navbar-nav mt-2 mt-lg-0'>
                <li className='nav-item active'>
                  <Form.Select
                    onChange={onChangeLanguage}
                    value={idiomDefault}>
                    {TranslationsOptions.map((t, index) => (
                      <option key={Math.random()} value={t.shortName}>
                        {t.name}
                      </option>
                    ))}
                  </Form.Select>
                </li>
              </ul>
              <ul className='navbar-nav mt-2 mt-lg-0 ml-2'>
                <li className='nav-item active'>
                  <div className="bg-danger align-items-center" style={{
                    textAlign: 'center',
                    verticalAlign: 'middle',
                    borderRadius: '100px',
                    color: '#fff',
                    margin: '0px',
                    padding: '8px 5px',
                    cursor: 'pointer'
                  }} onClick={handleOpenModalEquipmentOverLimit}>
                    <FontAwesomeIcon icon={faBell} className='me-2 w-100' shake={equipmentOverLimitList != null && equipmentOverLimitList.length > 0} size='xl' />
                  </div>
                </li>
              </ul>
              <ul className='navbar-nav mt-2 mt-lg-0 ms-2'>
                <li className='nav-item active'>
                  <Dropdown>
                    <Dropdown.Toggle className='nav-link user-prefix'>
                      <FontAwesomeIcon icon={faUser} />&nbsp;
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item onClick={ChangePassword}>
                        <FontAwesomeIcon icon={faLock} />&nbsp;
                        {t('BUTTON_CHANGE_PASSWORD')}
                      </Dropdown.Item>
                      <Dropdown.Item onClick={ChangePreferences}>
                        <FontAwesomeIcon icon={faGear} />&nbsp;
                        {t('BUTTON_PREFERENCES')}
                      </Dropdown.Item>
                      <Dropdown.Item onClick={Logout}>
                        <FontAwesomeIcon icon={faSignOutAlt} />&nbsp;
                        {t('BUTTON_LOGOUT')}
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};
